export const ucFirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
export const loginToken = () => {
    return localStorage.getItem('_Bearer')
};